import { FiPlus } from "react-icons/fi";
import {
  checkpointTemplatePathById,
  emailTemplatePathById,
  meetingTemplatePathById,
  messageTemplatePathById,
  taskTemplatePathById,
} from "helpers/url/pages/v2/actionPaths";
import { useNavigate } from "react-router";
import { TertiaryButton } from "components/Button";
import { ActionType } from "features/Resources/Shared/models";
import { useCallback } from "react";

export default function NewTemplateButton({ actionType }: { actionType: ActionType }) {
  const navigate = useNavigate();
  const onClick = useCallback(() => {
    switch (actionType) {
      case "email":
        navigate(emailTemplatePathById("new"));
        break;
      case "message":
        navigate(messageTemplatePathById("new"));
        break;
      case "task":
        navigate(taskTemplatePathById("new"));
        break;
      case "meeting":
        navigate(meetingTemplatePathById("new"));
        break;
      case "checkpoint":
        navigate(checkpointTemplatePathById("new"));
        break;
    }
  }, [actionType, navigate]);
  return (
    <TertiaryButton leftIcon={<FiPlus />} size="sm" onClick={onClick}>
      New
    </TertiaryButton>
  );
}
